/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var SecLicenseAddressSectionView = require('../views/SecLicenseAddressSectionView');
var GetLicenseAddressByObject = require('../services/GetLicenseAddressByObject');

module.exports = {
  channel: 'sc',

  event: 'build:license-address-view',

  builder: function(data) {
    return new PlaceholderView({
      viewPromise: buildSecLicenseAddressSectionView(data)
    });
  }
};

function buildSecLicenseAddressSectionView(data) {
  var deferred = $.Deferred();
  GetLicenseAddressByObject({ objectId: data.objectId, objectTypeId: data.objectTypeId })
    .done(function(licenseAddresses) {
      deferred.resolve(
        new SecLicenseAddressSectionView({
          objectTypeId: data.objectTypeId,
          model: new Backbone.Model({ licenseAddresses: licenseAddresses })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
